// Angular
import { Directive, Input } from '@angular/core';

export interface ToggleOptions {
	target?: string;
	targetState?: string;
	togglerState?: string;
}

/**
 * Toggle
 */
@Directive({
	selector: '[ktToggle]',
	exportAs: 'ktToggle',
})
export class ToggleDirective {
	// Public properties
	@Input() options!: ToggleOptions;
	toggle: any;
}
